export default "__VITE_ASSET__DrLtySJB__"